import {
  Box, Checkbox, FormControlLabel, FormGroup, Grid, Typography,
} from '@mui/material';
import LimiterInput from './LimiterInput';
import { InputLimits } from '../../../../enums/InputLimits';

function GoogleAnalyticsSetting(props: {
  googleAnalyticsScript: string,
  isRobotsNoindex: boolean,
  onGoogleAnalyticsScriptChange: (value: string) => void,
  onIsRobotsNoindexChange: (value: boolean) => void,
}) {
  const {
    googleAnalyticsScript,
    isRobotsNoindex,
    onGoogleAnalyticsScriptChange,
    onIsRobotsNoindexChange,
  } = props;

  return (
    <Box display="flex" flexDirection="column" rowGap="10px">
      <Box>
        <h2 className="mb-2">Google Analytics</h2>
      </Box>
      <Box className="pb-2">
        <hr className="mt-4" />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LimiterInput
              textarea
              label="GA4 Measurement ID"
              limit={InputLimits.GA4_SCRIPT}
              value={googleAnalyticsScript || ''}
              onChange={(newValue) => onGoogleAnalyticsScriptChange(newValue)}
              placeholder="Paste code here."
            />

            <Typography variant="caption" display="block">
              *This tag will be embedded immediately before &lt;/head&gt;.
            </Typography>
            <Typography variant="caption">
              *Copy and paste your GA4 tracking code from Google Analytics.
            </Typography>
          </Grid>
        </Grid>
        <hr className="mt-4" />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" className="text-bold mb-2">
              Search Visibility
            </Typography>
            <FormGroup>
              <FormControlLabel
                control={(
                  <Checkbox
                    size="small"
                    checked={isRobotsNoindex}
                    onChange={(e) => onIsRobotsNoindexChange(e.target.checked)}
                  />
                )}
                label="Hide this page from search engines"
                sx={{
                  '& .MuiFormControlLabel-label': { fontSize: '14px' },
                }}
              />
            </FormGroup>
            <Typography variant="caption" style={{ lineHeight: '0' }}>
              *Prevents this page from being indexed by search engines like Google.
              <br />
              *A &quot;noindex&quot; tag will be added.
              <br />
              {'  Tag: <meta name=”robots” content=”noindex”>'}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default GoogleAnalyticsSetting;
